import { ChangeDetectionStrategy, Component } from '@angular/core';
import { getStateCourt } from '@shared/utils';
import { CcsSkeletonComponent } from '@shared/components';

@Component({
  selector: 'app-toolbar-avatar-list',
  imports: [CcsSkeletonComponent],
  templateUrl: './toolbar-avatar-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarAvatarListComponent {
  protected readonly court = getStateCourt();
  protected imageLoaded: Record<number, boolean> = {};
}
